function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-statements */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { Translate } from "../../../I18N";
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { InputField, RadioSelect } from '.';
import { Pill } from "../UI/Pill";
import { Label } from "./Label";
import { Checkbox } from "./Checkbox";



















const SelectedCounter = ({ selectedItems }) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Selected"), " ", selectedItems.length ? `(${selectedItems.length})` : ''
);


const MultiselectList = ({
  items,
  onChange,
  className,
  label,
  hasErrors,
  value = [],
  checkboxes = false,
  foldableGroups = false
}) => {
  const [selectedItems, setSelectedItems] = useState(value);
  const [showAll, setShowAll] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState(items);
  const [openGroups, setOpenGroups] = useState([]);

  useEffect(() => {
    if (onChange) onChange(selectedItems);
  }, [onChange, selectedItems]);

  useEffect(() => {
    let filtered = [...items];
    if (!showAll) {
      filtered = filtered.
      filter((item) => {var _item$items;
        const itemiSelected = selectedItems.includes(item.value);
        const containsSelected = (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.some((childItem) =>
        selectedItems.includes(childItem.value)
        );

        return itemiSelected || containsSelected;
      }).
      map((item) => {
        if (item.items) {
          return _objectSpread(_objectSpread({},
          item), {}, {
            items: item.items.filter((childItem) => selectedItems.includes(childItem.value)) });

        }
        return item;
      });
    }

    if (!searchTerm) {
      setFilteredItems(filtered);
      return;
    }

    filtered = filtered.
    filter(({ searchLabel }) => searchLabel.toLowerCase().includes(searchTerm.toLowerCase())).
    map((item) => {
      if (item.items) {
        return _objectSpread(_objectSpread({},
        item), {}, {
          items: item.items.filter(({ searchLabel }) =>
          searchLabel.toLowerCase().includes(searchTerm.toLowerCase())
          ) });

      }
      return item;
    });

    setFilteredItems(filtered);
  }, [items, searchTerm, showAll, selectedItems]);

  const handleSelect = (_value) => {
    if (selectedItems.includes(_value)) {
      setSelectedItems(selectedItems.filter((item) => item !== _value));
    } else {
      setSelectedItems([...selectedItems, _value]);
    }
  };

  const applyFilter = ({ target }) => {
    setShowAll(target.value === 'true');
  };

  const renderButtonItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }

    const selected = selectedItems.includes(item.value);
    const borderSyles = selected ?
    'border-sucess-200' :
    'border-transparent hover:border-primary-300';

    return /*#__PURE__*/(
      _jsx("li", { className: "mb-4" }, item.value, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: `w-full flex text-left p-2.5 border ${borderSyles} rounded-lg items-center`,
        onClick: () => handleSelect(item.value) }, void 0, /*#__PURE__*/

      _jsx("span", { className: "flex-1" }, void 0, item.label), /*#__PURE__*/
      _jsx("div", { className: "flex-1" }, void 0, /*#__PURE__*/
      _jsx(Pill, { className: "float-right", color: selected ? 'green' : 'primary' }, void 0,
      selected ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Selected") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Select")
      )
      )
      )
      ));

  };

  const renderCheckboxItem = (item) => {
    if (item.items) {
      return renderGroup(item);
    }
    const selected = selectedItems.includes(item.value);
    return /*#__PURE__*/(
      _jsx("li", { className: "mb-2" }, item.value, /*#__PURE__*/
      _jsx(Checkbox, {
        name: item.value,
        label: item.label,
        checked: selected,
        onChange: () => handleSelect(item.value) }
      )
      ));

  };

  const handleGroupToggle = (groupKey) => {
    if (openGroups.includes(groupKey)) {
      setOpenGroups(openGroups.filter((group) => group !== groupKey));
    } else {
      setOpenGroups([...openGroups, groupKey]);
    }
  };

  const isGroupOpen = (groupKey) => openGroups.includes(groupKey);

  const renderItem = (item) =>
  checkboxes ? renderCheckboxItem(item) : renderButtonItem(item);

  const renderGroup = (group) => {var _group$items2;
    const isOpen = isGroupOpen(group.value);
    if (foldableGroups) {var _group$items;
      return /*#__PURE__*/(
        _jsx("li", { className: "mb-4" }, group.value, /*#__PURE__*/
        _jsx("div", {
          className: `flex justify-between p-3 mb-4 rounded-lg ${isOpen ? 'bg-indigo-50' : 'bg-gray-50'}`,
          onClick: () => handleGroupToggle(group.value) }, void 0, /*#__PURE__*/

        _jsx("span", { className: "block text-sm font-bold text-gray-900" }, void 0, group.label), /*#__PURE__*/
        _jsx("button", {
          className: "text-indigo-800 bg-indigo-200 rounded-[6px] text-xs font-medium px-1.5 py-0.5 flex flex-row items-center justify-center gap-1",
          type: "button" }, void 0, /*#__PURE__*/

        _jsx("div", { className: "w-3 h-3 text-sm" }, void 0,
        isOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {})
        ), /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Properties")
        )
        ),
        isOpen && /*#__PURE__*/_jsx("ul", { className: "pl-4" }, void 0, (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(renderItem))
        ));

    }

    return /*#__PURE__*/(
      _jsx("li", { className: "mb-4" }, group.value, /*#__PURE__*/
      _jsx("span", { className: "block mb-4 text-sm font-bold text-gray-900" }, void 0, group.label), /*#__PURE__*/
      _jsx("ul", { className: "" }, void 0, (_group$items2 = group.items) === null || _group$items2 === void 0 ? void 0 : _group$items2.map(renderItem))
      ));

  };

  return /*#__PURE__*/(
    _jsx("div", { className: `flex flex-col relative ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sticky top-0 w-full px-2 mb-4" }, void 0, /*#__PURE__*/
    _jsx(Label, { htmlFor: "search-multiselect", hideLabel: !label, hasErrors: Boolean(hasErrors) }, void 0,
    label
    ), /*#__PURE__*/
    _jsx(InputField, {
      id: "search-multiselect",
      label: "search-multiselect",
      hideLabel: true,
      onChange: (e) => setSearchTerm(e.target.value),
      placeholder: "Search",
      value: searchTerm,
      clearFieldAction: () => setSearchTerm('') }
    ), /*#__PURE__*/
    _jsx(RadioSelect, {
      name: "filter",
      orientation: "horizontal",
      options: [
      {
        label: /*#__PURE__*/_jsx(Translate, {}, void 0, "All"),
        value: 'true',
        defaultChecked: true
      },
      {
        label: /*#__PURE__*/_jsx(SelectedCounter, { selectedItems: selectedItems }),
        value: 'false',
        disabled: selectedItems.length === 0
      }],

      onChange: applyFilter,
      className: "px-1 pt-4" }
    )
    ), /*#__PURE__*/

    _jsx("ul", { className: "px-2 w-full overflow-y-scroll max-h-[calc(100vh_-_9rem)]" }, void 0,
    filteredItems.map(renderItem)
    )
    ));

};

export { MultiselectList };